import baseAPIAction from "REDUX/BaseAPIAction";
import { API } from "CONSTANTS/AppConstants";
import { Strings } from "INTL/i18n";
import { API_RESPONSE_STATUS_CODE } from "../../../config/axios.init";

export default function makePayment(
  token,
  paymentGatewayCode,
  makePaymentActionCallback
) {
  const API_Call_Details =
    API.makePayment +
    "?token=" +
    token +
    "&paymentGatewayCode=" +
    paymentGatewayCode;

  return function(dispatch) {
    // baseAPIAction(API_Call_Details, makePaymentAPICallback,config);
    baseAPIAction(API_Call_Details, makePaymentAPICallback, {});
    // baseAPIAction("https://testsecureacceptance.cybersource.com/pay", makePaymentAPICallback,config,"post",formData);
    function makePaymentAPICallback(errorMessage, responseData) {
      if (errorMessage === "") {
        if (responseData.status !== API_RESPONSE_STATUS_CODE.SUCCESS) {
          if (responseData.status === API_RESPONSE_STATUS_CODE.TOKEN_EXPIRED) {
            errorMessage = Strings("tokenExpiredMakeNewRequest");
          } else if (
            responseData.status === API_RESPONSE_STATUS_CODE.TOKEN_NOT_FOUND
          ) {
            errorMessage = Strings("tokenNotFound");
          } else if (
            responseData.status ===
            API_RESPONSE_STATUS_CODE.TOKEN_ALREADY_PROCESSED
          ) {
            errorMessage = Strings("tokenAlreadyProcessed");
          } else if (
            responseData.status ===
            API_RESPONSE_STATUS_CODE.MAXIMUM_RETRY_ATTEMPTS_REACHED
          ) {
            errorMessage = Strings("maximumRetryAttemptReached");
          } else if (
            responseData.status === API_RESPONSE_STATUS_CODE.KNET_INIT_FAIL
          ) {
            errorMessage = Strings("knetInitFailed");
          } else errorMessage = Strings("internalError");
        }
      }
      makePaymentActionCallback(errorMessage, responseData);
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/Payer/actions/MakePayment.js